import { getProgramNameFromRecord } from './vmt';
import { resolveProgramName } from './dataNormalizer';

const syncThrottleDelayMs = Number(import.meta.env?.VITE_VMT_BULK_SEND_DELAY_MS || 400);
const SYNC_REFRESH_BAC_THRESHOLD = 4;

const SYNC_UNKNOWN_TOKENS = new Set(['unknown', 'n/a', 'na', 'tbd', 'null']);

const isUnknownDiValue = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return true;
    return SYNC_UNKNOWN_TOKENS.has(trimmed.toLowerCase());
  }
  return false;
};

const getSyncStatusMeta = (status) => {
  switch (status) {
    case 'success':
      return { label: 'Success', color: 'success' };
    case 'failed':
      return { label: 'Failed', color: 'error' };
    case 'skipped':
      return { label: 'Skipped', color: 'warning' };
    case 'sending':
      return { label: 'Sending', color: 'info' };
    case 'queued':
      return { label: 'Queued', color: 'default' };
    default:
      return { label: 'Pending', color: 'default' };
  }
};

const resolveSyncBacValue = (row) => {
  if (!row) return '';
  const source = row.sourceEnrollment || row.source || row;
  return source?.bac ?? row?.bac ?? '';
};

const resolveSyncProgramNameValue = (row) => {
  if (!row) return '';
  const candidate =
    getProgramNameFromRecord(row) ||
    row?.programName ||
    row?.programLabel ||
    row?.programCode ||
    row?.program ||
    '';
  const resolved = resolveProgramName(candidate);
  return resolved || (candidate ? String(candidate).trim() : '');
};

const buildSyncRefreshPlan = (rows = []) => {
  const targets = [];
  const seenTargets = new Set();
  const bacSet = new Set();

  rows.forEach((row) => {
    const bac = String(resolveSyncBacValue(row) || '').trim();
    const programName = String(resolveSyncProgramNameValue(row) || '').trim();
    if (!bac || !programName) return;
    const key = `${programName}::${bac}`;
    if (!seenTargets.has(key)) {
      seenTargets.add(key);
      targets.push({ programName, bac });
    }
    bacSet.add(bac);
  });

  return { targets, uniqueBacCount: bacSet.size };
};

export {
  buildSyncRefreshPlan,
  getSyncStatusMeta,
  isUnknownDiValue,
  resolveSyncBacValue,
  resolveSyncProgramNameValue,
  syncThrottleDelayMs,
  SYNC_REFRESH_BAC_THRESHOLD,
};
